
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import axios from "axios";

import Spinner from "../../spinners/DataSpinner";

const ViewProducts = () => {

    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState([]);


    useEffect(() => {

        document.title = "View Products";

        axios.get(`api/view-products`)
            .then(res => {
                if (res.data.status === 200) {
                    setProductList(res.data.products);
                };
                setLoading(false);
            });
    }, []);

    let dataTableData = '';
    if (loading) {
        return <Spinner/>
    } else {
        let productStatusName = ""; 
        let productStatusClass = ""; 
        dataTableData =
            productList.map((item) => {
                if(item.status==1){
                    productStatusName = "Shown";
                    productStatusClass = "success";
                }else{
                    productStatusName = "Hidden";
                    productStatusClass = "danger";
                }
                return (
                    <tr key={item.id}>
                        <td className="align-middle">{item.id}</td>
                        <td className="align-middle">{item.category.name}</td>
                        <td className="align-middle">{item.name}</td>
                        <td className="align-middle">{item.sale_price}</td>
                        <td className="align-middle">{item.original_price}</td>
                        <td className="align-middle">
                            <img className="rounded" alt={item.name} src={`${process.env.REACT_APP_API_URL}/public/uploads/products/${item.image}`} width="50" />
                        </td>
                        <td className="align-middle">
                            <Link to={`/admin/edit-product/${item.id}`} className="btn btn-success btn-sm">Edit</Link>
                        </td>
                        <td className="align-middle">
                            <span className={`badge badge-${productStatusClass}`}>{productStatusName}</span>
                        </td>
                    </tr>
                );
            });
    }

    return (
        <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 className="h5 mb-0 text-gray-800">View Products</h3>
                <Link to="/admin/add-product" className="btn btn-primary btn-md">Add Product</Link>
            </div>
            <div className="card-body">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="align-middle">ID</th>
                            <th className="align-middle">Category</th>
                            <th className="align-middle">Name</th>
                            <th className="align-middle">Sale Price</th>
                            <th className="align-middle">Original Price</th>
                            <th className="align-middle">Image</th>
                            <th className="align-middle">Edit</th>
                            <th className="align-middle">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataTableData}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ViewProducts;